import { createAction } from 'typesafe-actions'
import { ModalState } from './reducer'

export const setModalOpen = createAction('SET_MODAL_OPEN')<ModalState>()
